export default __webpack_public_path__ + "assets/snow-f15cd637.mp4";